import { render } from "./NavElemSelector.vue?vue&type=template&id=0540b298"
import script from "./NavElemSelector.vue?vue&type=script&lang=js"
export * from "./NavElemSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__